import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SessionService } from '../../core/services/session.service';
import { UntypedFormGroup } from '@angular/forms';
import { switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CompareValidation } from '@app/core/validation/comparison-validation';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'itfg-reset-password-form',
    templateUrl: './reset-password-form.component.html',
    styleUrls: ['./reset-password-form.component.scss'],
    standalone: false
})
export class ResetPasswordFormComponent implements OnInit, OnDestroy {
  @Input() token: string;

  loginErrored: boolean;
  passwordResetForm: UntypedFormGroup;
  showForgotPassword: boolean = false;
  _unsubscribe: Subject<void> = new Subject<void>();
  loginErrorMessage = '';

  constructor(
    private session: SessionService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private translateService: TranslateService,
  ) {

    this.passwordResetForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64)]],
      passwordConfirm: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64)]],
      // oldPassword: [null],
    }, {
      validators: CompareValidation.fieldsAreEqualV2('passwordsNotEqual', [
        'password',
        'passwordConfirm',
      ]),
    })
  }

  ngOnInit() {
    // TODO: check if token is valid?
  }

  onSubmit(event): void {
    if (this.passwordResetForm.valid) {
      this.loginErrored = false;
      const password = this.passwordResetForm.value['password'];

      this.session.resetPassword(this.token, password)
        .pipe(switchMap((operator) => this.session.login({ username: operator['email'], password })))
        .subscribe({
          next: (res) => {
            if (res === 423) {
              this.router.navigateByUrl("/");
            }
            if (!res) {
              this.loginErrored = true;
            }
          },
          error: (err) => {
            this.loginErrored = true;
            this.loginErrorMessage = this.translateService.instant("auth.passwordValidation.errorCodes." + err.error[0].code);
          }
        });
    }
  }


  ngOnDestroy() {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
